import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const SPECS = {
  ...SdkSpecs,
  SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON: 'specs.stores.SubscriptionPlanUseTpaRadioButton',
  USE_LIGHTBOXES: 'specs.stores.UseLightboxes',
  EDITOR_OOI: 'specs.stores.EditorGalleryOOI',
  DISABLE_MOBILE_NATIVE_DROPDOWN: 'specs.stores.DisableMobileNativeDropdown',
  FIX_CASHIER_PROPS_PRICE_SHIFTING: 'specs.stores.ProductPageFixCashierPropsPriceShifting',
  LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE:
    'specs.stores.ProductPageLocationOnChangePathChangeForEditorSausage',
  PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION: 'specs.stores.ProductPageMigrateToRicoDescription',
  PRODUCT_PAGE_SLOTS: 'specs.stores.ProductPageSlots',
  EnableDynamicSizeDefaultImage: 'specs.stores.EnableDynamicSizeDefaultImage',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  MainMediaWrapperAsAnchorElement: 'specs.stores.MainMediaWrapperAsAnchorElement',
  ProductPageUpliftProductOptionsViewer: 'specs.stores.ProductPageUpliftProductOptionsViewer',
  SubscriptionPlansNewDesignViewer: 'specs.stores.SubscriptionPlansNewDesignViewer',
  ProductPageSupportGridLayout: 'specs.stores.ProductPageSupportGridLayout',
  InfoSectionTabsTPAComponent: 'specs.stores.InfoSectionTabsTPAComponent',
  AllowExpandFirstInfoSectionsStorefront: 'storesAllowExpandFirstInfoSectionsStorefront',
  LoadClientConfigInController: 'specs.stores.LoadClientConfigInController',
  AllowProductPageButtonsOption: 'specs.stores.allowProductPageButtonsOption',
  ProductMediaNavigationDots: 'specs.stores.ProductMediaNavigationDots',
  ProductPageFixReflowSausageNavigation: 'specs.stores.ProductPageFixReflowSausageNavigation',
  MediaSlotOnBottomForResponsiveGallery: 'specs.stores.ResponsiveLayoutMediaSlotBottom',
  ProductPageConsumePublicDataFromBothScopes: 'specs.stores.ProductPageConsumePublicDataFromBothScopes',
  FixVariantIdCalculationInBuyNowFlow: 'specs.stores.FixVariantIdCalculationInBuyNowFlow',
  UseExperimentsFromPlatformFlowApi: 'specs.stores.UseExperimentsFromPlatformFlowApi',
  ProductPageRemovePagination: 'specs.stores.ProductPageRemovePagination',
  ProductNameHtmlTag: 'specs.stores.ProductNameHtmlTag',
  ResponsiveEditorBreadcrumbsToggle: 'specs.stores.ResponsiveEditorBreadcrumbsToggle',
  FixClassicMobileNavigationVisibility: 'storesFixClassicMobileNavigationVisibility',
  ProductPageVideoPosterOptimization: 'specs.stores.ProductPageVideoPosterOptimization',
  StoresStickyAddToCart: 'storesStickyAddToCart',
  FixProductPageDropdownMobileSsr: 'specs.stores.FixProductPageDropdownMobileSsr',
  CheckoutPagePreviewEnabled: 'specs.stores.CheckoutPagePreviewEnabled',
  AddDiscountsToVariantsItemsQueries: 'specs.stores.AddDiscountsToVariantsItemsQueries',
  ShowUserWishlistStateInProductPage: 'specs.stores.ShowUserWishlistStateInProductPage',
  CombinedListing: 'specs.stores.CombinedListing',
  ProductPageWishlistTrackEvent: 'specs.stores.ProductPageWishlistTrackEvent',
  ProductPageDescriptionToggle: 'specs.stores.ProductPageDescriptionToggle',
  UseCartV2ForDirectPurchase: 'specs.stores.UseCartV2ForDirectPurchase',
  OnlineStoresCurrencyClientFormatting: 'specs.stores.OnlineStoresCurrencyClientFormatting',
  UseGetClientConfigFromPublicApi: 'specs.stores.UseGetClientConfigFromPublicApi',
  ProductPageMainMediaNavigationArrows: 'specs.stores.ProductPageMainMediaNavigationArrows',
  ShowMultiRibbonsInProductPage: 'specs.stores.ShowMultiRibbonsInProductPage',
  MoveCustomUrlApiToSiteStoreConstructor: 'specs.stores.MoveCustomUrlApiToSiteStoreConstructor',
  ZoomableMainMedia: 'specs.stores.ZoomableMainMedia',
  FixPPThumbnailSliderNavigation: 'fixPPThumbnailSliderNavigation',
  FixProductPageDescriptionReadMore: 'specs.stores.FixProductPageDescriptionReadMore',
  FixProductPageHistoricalBreadcrumbsStyleParams: 'specs.stores.FixProductPageHistoricalBreadcrumbsStyleParams',
  ShowFromTextOnFullSelectedVariant: 'specs.stores.ShowFromTextOnFullSelectedVariant',
  FixPreviewCustomProductUrlSlug: 'specs.stores.FixPreviewCustomProductUrlSlug',
  FixPPAddToCartButtonTextKeyPriority: 'specs.stores.FixPPAddToCartButtonTextKeyPriority',
  PPAlignFontSizeToModernLayout: 'specs.stores.PPAlignFontSizeToModernLayout',
  FixUrlDoubleDecoding: 'fixPPUrlDoubleDecoding',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  ProductPageRemoveOptionPreselection: 'storesProductPageRemoveOptionPreselection',
  addProductOptionsToQueryParams: 'addProductOptionsToQueryParams',
  StoresPreselectSubscriptions: 'storesPreselectSubscriptions',
  ShowHiddenVariants: 'storesShowHiddenVariants',
  OptionalModifiersProductPage: 'optionalModifiersProductPage',
};
